import { render, staticRenderFns } from "./Prelim.vue?vue&type=template&id=1b681795&scoped=true&"
import script from "./Prelim.vue?vue&type=script&lang=js&"
export * from "./Prelim.vue?vue&type=script&lang=js&"
import style0 from "./Prelim.vue?vue&type=style&index=0&id=1b681795&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b681795",
  null
  
)

export default component.exports